import { render, staticRenderFns } from "./i-dots.vue?vue&type=template&id=4688e46c&scoped=true&"
import script from "./i-dots.vue?vue&type=script&lang=js&"
export * from "./i-dots.vue?vue&type=script&lang=js&"
import style0 from "./i-dots.vue?vue&type=style&index=0&id=4688e46c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688e46c",
  null
  
)

export default component.exports